import { CompanyType, Priority, SmartTaskType, TaskStatus, UpdateOnCompletion } from '@/shared/types/enum';
import {
  formatClassName,
  formatDate,
  formatDayLongMonth,
  formatDayMonth,
  formatDayMonthYear,
  formatDayMonthYearTime,
  formatEnum,
  formatTime,
} from '@/shared/utils/format';
import { dueDateClass } from '@/shared/utils/style';

import { formatSearchResultName, formatSearchResultType } from '@/front/search';

const wrap = (formatter: (value: any) => string) => {
  return (value: any) => {
    try {
      return formatter(value);
    } catch (e) {
      console.error(e);
      return '';
    }
  };
};

(window as any).formatters = {
  dueDateClass: wrap(dueDateClass),
  formatClassName: wrap(formatClassName),
  formatDayMonth: wrap(formatDayMonth),
  formatDayLongMonth: wrap(formatDayLongMonth),
  formatDayMonthYear: wrap(formatDayMonthYear),
  formatDate: wrap(formatDate),
  formatTime: wrap(formatTime),
  formatDayMonthYearTime: wrap(formatDayMonthYearTime),
  formatSearchResultName: wrap(formatSearchResultName),
  formatSearchResultType: wrap(formatSearchResultType),

  formatCompanyType: wrap((value: any) => formatEnum(CompanyType, value)),
  formatTaskStatus: wrap((value: any) => formatEnum(TaskStatus, value)),
  formatSmartTaskType: wrap((value: any) => formatEnum(SmartTaskType, value)),
  formatUpdateOnCompletion: wrap((value: any) => formatEnum(UpdateOnCompletion, value)),
  formatPriority: wrap((value: any) => formatEnum(Priority, value)),
};
